export default function FinalCTA() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      className="relative py-28 overflow-hidden"
      style={{ background: 'linear-gradient(135deg, #050d18 0%, #0a1520 100%)' }}
    >
      {/* Decorative elements */}
      <div
        className="absolute top-0 left-0 right-0 h-px"
        style={{ background: 'linear-gradient(to right, transparent, rgba(212,175,55,0.4) 30%, rgba(212,175,55,0.4) 70%, transparent)' }}
      ></div>
      <div
        className="absolute -top-60 -right-60 rounded-full"
        style={{ width: '500px', height: '500px', background: 'rgba(212,175,55,0.025)', filter: 'blur(80px)' }}
      ></div>
      <div
        className="absolute -bottom-60 -left-60 rounded-full"
        style={{ width: '500px', height: '500px', background: 'rgba(212,175,55,0.025)', filter: 'blur(80px)' }}
      ></div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-10 text-center">
        <span
          className="text-[#d4af37] text-[10px] uppercase tracking-[4px] font-bold block mb-6"
          style={{ fontFamily: "'Montserrat', sans-serif" }}
        >
          Get Protected
        </span>
        <h2
          className="font-black text-white mb-8 leading-tight"
          style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 'clamp(2.2rem, 5vw, 4rem)', letterSpacing: '-0.02em' }}
        >
          Protect Your Property
          <br />
          <span className="text-[#d4af37]">Built to Last. Backed by Integrity.</span>
        </h2>
        <p
          className="text-white/50 text-base leading-[1.85] mb-12 max-w-2xl mx-auto"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          Whether you need roof replacement, repair, gutter systems, or solar installation — Shadowfax Roofing &amp; Solar delivers solutions designed for durability and long-term performance across Campbell and the South Bay.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => handleNav('#contact')}
            className="group flex items-center justify-center gap-3 text-[#1a1a1a] font-bold text-xs px-12 py-5 rounded transition-all duration-300 cursor-pointer whitespace-nowrap uppercase tracking-[2px]"
            style={{ fontFamily: "'Montserrat', sans-serif", background: '#d4af37' }}
            onMouseEnter={e => (e.currentTarget.style.background = '#c4a030')}
            onMouseLeave={e => (e.currentTarget.style.background = '#d4af37')}
          >
            Get Your Free Estimate
            <div className="w-5 h-5 flex items-center justify-center group-hover:translate-x-1 transition-transform duration-300">
              <i className="ri-arrow-right-line"></i>
            </div>
          </button>
          <a
            href="tel:4086280065"
            className="flex items-center justify-center gap-3 font-bold text-xs px-12 py-5 rounded transition-all duration-300 whitespace-nowrap uppercase tracking-[2px]"
            style={{ fontFamily: "'Montserrat', sans-serif", border: '1px solid rgba(212,175,55,0.4)', color: '#d4af37' }}
            onMouseEnter={e => { (e.currentTarget as HTMLElement).style.borderColor = 'rgba(212,175,55,0.8)'; (e.currentTarget as HTMLElement).style.background = 'rgba(212,175,55,0.05)'; }}
            onMouseLeave={e => { (e.currentTarget as HTMLElement).style.borderColor = 'rgba(212,175,55,0.4)'; (e.currentTarget as HTMLElement).style.background = 'transparent'; }}
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill"></i>
            </div>
            Call (408) 628-0065
          </a>
        </div>

        {/* Trust micro-signals */}
        <div
          className="flex flex-wrap items-center justify-center gap-8 mt-14 pt-10"
          style={{ borderTop: '1px solid rgba(255,255,255,0.07)' }}
        >
          {[
            { icon: 'ri-shield-check-line', text: 'Licensed & Insured' },
            { icon: 'ri-home-heart-line', text: 'Family-Owned' },
            { icon: 'ri-map-pin-2-line', text: 'Campbell, CA' },
            { icon: 'ri-time-line', text: 'Mon–Sat 7am–6pm' },
          ].map((item, i) => (
            <div key={i} className="flex items-center gap-2">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={`${item.icon} text-[#d4af37] text-sm`}></i>
              </div>
              <span
                className="text-white/35 text-[10px] uppercase tracking-[2px]"
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                {item.text}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
